import { get_wind_zLevel_colors } from "../api/meteorologicalSea.js";
export default {
  state: {
    visible: false,
    colors: [],
    fillColorExpressions: [],
    activeData: {
      min: 0,
      max: 0,
      datetimeSet: [],
      marks: {},
      forecastData: {},
    },
  },
  actions: {
    meteorologicalShow({ state }) {
      state.visible = true;
    },
    meteorologicalHide({ state }) {
      state.visible = false;
    },
    get_wind_zLevel_colors({ state }) {
      return new Promise((resolve, reject) => {
        get_wind_zLevel_colors()
          .then((response) => {
            // h5 request 返回响应体本身，颜色数据在 result 字段下
            const colors =
              (Array.isArray(response?.result) && response.result) ||
              (Array.isArray(response?.data?.data) && response.data.data) ||
              (Array.isArray(response?.data) && response.data) ||
              [];
            state.colors = colors;
            if (colors.length) {
              state.fillColorExpressions = [
                "case",
                ["has", "windZLevel"],
                [
                  "match",
                  ["get", "windZLevel"],
                  ...colors
                    .map((colorItem) => [
                      colorItem.value.toString(),
                      colorItem.color,
                    ])
                    .flat(),
                  colors[0].color,
                ],
                "#FFFFFF",
              ];
            }
            resolve();
          })
          .catch((e) => reject(e));
      });
    },
  },
};
